import React, { useState, useEffect, useCallback } from 'react';
import { Loader, CheckCircle, ArrowRight } from 'lucide-react';
import { BACKEND_URL } from '../config';

const JoinDiscordStep3 = ({ token }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [canProceed, setCanProceed] = useState(false);

  const checkReadiness = useCallback(async () => {
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${BACKEND_URL}/api/onboarding`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'check-discord-step',
          token: token,
        }),
      });

      const data = await response.json();

      if (data.discord_join_step === '2/3') {
        setCanProceed(true);
      } else if (data.discord_join_step === '3/3') {
        window.location.href = `/complete?token=${token}`;
      } else {
        setError('Debes completar los pasos anteriores primero.');
      }
    } catch {
      setError('Error al verificar. Intenta de nuevo.');
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) checkReadiness();
    else setError('Token no encontrado.');
  }, [token, checkReadiness]);

  const handleContinue = () => {
    window.location.href = `/complete?token=${token}`;
  };

  if (isLoading) {
    return (
      <div className="text-center py-8">
        <Loader className="w-16 h-16 text-yellow-500 animate-spin mx-auto mb-6" />
        <h2 className="text-2xl font-bold text-white mb-4">Verificando...</h2>
        <p className="text-gray-400">Estamos verificando tu progreso.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-red-500/10 rounded-full mb-6">
          <CheckCircle className="w-12 h-12 text-red-500" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-4">Error</h2>
        <p className="text-red-400 mb-6">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-700 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-xl transition-all"
        >
          Reintentar
        </button>
      </div>
    );
  }

  if (canProceed) {
    return (
      <div className="text-center py-8">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-500/10 rounded-full mb-6 animate-bounce">
          <CheckCircle className="w-12 h-12 text-green-500" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">¡Todo Listo!</h2>
        <p className="text-gray-300 mb-2">
          Has completado todos los pasos exitosamente.
        </p>
        <p className="text-gray-400 text-sm mb-8">
          Ahora puedes continuar al último paso para reclamar tu role oficial.
        </p>

        <button
          onClick={handleContinue}
          className="w-full max-w-md mx-auto bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-yellow-500/50 flex items-center justify-center gap-3"
        >
          Continuar <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    );
  }

  return null;
};

export default JoinDiscordStep3;